import {RegionModel} from './RegionModel';
import {RoleAnagrafModel} from './RoleAnagrafModel';
import {RateTypeModel} from './RateTypeModel';
import {CurrencyModel} from './CurrencyModel';

export class RateCardModel{

  region: RegionModel;
  currency: CurrencyModel;
  roles: RoleAnagrafModel;
  rateType: RateTypeModel;
  transitionOs: boolean;
  onsiteFts: boolean;
  hours: number ;
  year1: number ;
  year1Ammount : number;
  year2: number ;
  year2Ammount : number;
  year3: number;
  year3Ammount : number;

  constructor(region?: RegionModel, currency?: CurrencyModel, role?: RoleAnagrafModel,
              rateType?: RateTypeModel, Transition_OS?: boolean, Onsite_FTS?: boolean, Hours?: number, year_1?: number,
              year_1_amount?: number, year_2?: number, year_2_amount?: number, year_3?: number, year_3_amount?: number) {
    this.region = region;
    this.currency = currency;
    this.roles = role;
    this.rateType = rateType;
    this.transitionOs = Transition_OS;
    this.onsiteFts = Onsite_FTS;
    this.hours = Hours;
    this.year1 = year_1;
    this.year1Ammount = year_1_amount;
    this.year2 = year_2;
    this.year2Ammount = year_2_amount;
    this.year3 = year_3;
    this.year3Ammount = year_3_amount;
  }
}

